import React from 'react'

export function ArrowRightIcon({color = '#ffffff'}) {
  return (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{display: 'block'}}
    >
      <path
        d="M13.3649 8.02841C13.366 8.02729 13.3671 8.02616 13.3683 8.02502L16.8397 4.529C16.8671 4.50123 16.8914 4.47053 16.9123 4.43748L16.9668 4.33681L16.9895 4.26817L16.9895 4.21783C17.0035 4.1407 17.0035 4.06161 16.9895 3.98446L16.9895 3.93871L16.9895 3.88379L16.9486 3.806C16.9253 3.76265 16.8963 3.72262 16.8624 3.68701L13.3683 0.177269C13.1371 -0.0577562 12.7607 -0.0592791 12.5276 0.17388C12.5265 0.174996 12.5254 0.176132 12.5242 0.177269C12.3001 0.414182 12.3001 0.786894 12.5242 1.02383L14.5935 3.11503C14.6812 3.20525 14.6798 3.35012 14.5903 3.43858C14.5487 3.47974 14.493 3.50317 14.4347 3.50398L0.594511 3.50398C0.266191 3.50396 2.84453e-05 3.77232 7.45003e-06 4.1034C-1.35453e-05 4.43447 0.266105 4.70285 0.594425 4.7029L14.4347 4.7029C14.5599 4.70468 14.6601 4.80854 14.6583 4.93488C14.6575 4.99365 14.6343 5.04987 14.5935 5.09185L12.5242 7.17391C12.2972 7.41143 12.2972 7.78753 12.5242 8.02504C12.7555 8.26007 13.1318 8.26159 13.3649 8.02841Z"
        fill={color}
      />
    </svg>
  )
}
